import { Controller } from "@hotwired/stimulus"

// Zen's Timer modal: every timer and the alarm in one dialog, opened from the
// Timer button in the header (and the alarm's countdown). A native <dialog>, so
// Escape closes it and focus stays inside; a click on the backdrop closes it too.
export default class extends Controller {
    static targets = ["dialog"]

    open(event) {
        if (event) event.preventDefault()
        if (!this.hasDialogTarget || this.dialogTarget.open) return
        this.dialogTarget.showModal()
    }

    close() {
        if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
    }

    // The dialog box itself fills its own rect; a click whose target is the
    // <dialog> element landed on the backdrop around it.
    backdrop(event) {
        if (event.target === this.dialogTarget) this.close()
    }
}
